import * as React from "react";
import { SVGProps } from "react";
export const ThumbDownFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.83335 0.833313L14.1667 0.833314L14.1667 11.6666L8.33335 17.5L7.29169 16.4583C7.19446 16.3611 7.1146 16.2291 7.0521 16.0625C6.9896 15.8958 6.95835 15.7361 6.95835 15.5833V15.2916L7.87502 11.6666H3.33335C2.88891 11.6666 2.50002 11.5 2.16669 11.1666C1.83335 10.8333 1.66669 10.4444 1.66669 9.99998L1.66669 8.33331C1.66669 8.23609 1.6771 8.13192 1.69794 8.02081C1.71877 7.9097 1.75002 7.80553 1.79169 7.70831L4.29169 1.83331C4.41669 1.55554 4.62502 1.31943 4.91669 1.12498C5.20835 0.930536 5.51391 0.833313 5.83335 0.833313ZM15.8334 11.6666L15.8334 0.833314L19.1667 0.833314V11.6666H15.8334Z"
            fill="currentColor"
        />
    </svg>
);
ThumbDownFillIcon.displayName = "ThumbDownFillIcon";
